<p>
  induction-modules-view works!
</p>
